import React from 'react';
import { Route, Switch } from 'react-router';

// const FSRUseCase = lazy(() => import('./FSR'));
import ArchiveFSR from './ArchiveFSR';
import FullService from './FullService';

const UseCases: React.FC = () => {
  return (
    <Switch>
      {/*<Route*/}
      {/*  path={'/use-cases/archive/fsr'}*/}
      {/*  exact*/}
      {/*  render={() => {*/}
      {/*    return <ArchiveFSR />;*/}
      {/*  }}*/}
      {/*/>*/}
      <Route
        path={'/use-cases/fsr'}
        exact
        render={() => {
          return <FullService />;
        }}
      />
    </Switch>
  );
};

export default UseCases;
